/**
 * Helper functions to map filter numeric IDs to API string values
 */

import { AmenityApiMapping, PropertyTypeApiMapping, ProvisionApiMapping } from '@app/enums';
import { MapAccommodationsFilters } from '@app/models';

export const mapPropertyTypesToApi = <TInput extends string | number | symbol, TOutput>(
    inputIds: Array<TInput>,
    apiMap: Record<TInput, TOutput>,
): Array<TOutput> => {
    return inputIds.map(id => apiMap[id]).filter(Boolean);
};

export const convertFiltersToApiParams = (filters: MapAccommodationsFilters) => {
    const { propertyTypeIds = [], amenityIds = [], provisionIds = [] } = filters;

    return {
        propertyType: mapPropertyTypesToApi<number, string>(
            propertyTypeIds,
            PropertyTypeApiMapping,
        ),
        amenities: mapPropertyTypesToApi<number, string>(amenityIds, AmenityApiMapping),
        provision: mapPropertyTypesToApi<number, string>(provisionIds, ProvisionApiMapping),
    };
};
